import { render, staticRenderFns } from "./DialogimportCustomer.vue?vue&type=template&id=46ad2d2a&scoped=true"
import script from "./DialogimportCustomer.vue?vue&type=script&lang=js"
export * from "./DialogimportCustomer.vue?vue&type=script&lang=js"
import style0 from "./DialogimportCustomer.vue?vue&type=style&index=0&id=46ad2d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ad2d2a",
  null
  
)

export default component.exports